
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_1152:717)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#F20808"}})]),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.108 29.274v-1.785H16.97v1.785h7.137zm8.92-6.245v-1.784H16.972v1.784H33.03zm0-6.245V15H16.972v1.784H33.03zm-.413 9.705l-1.894 1.892 1.893 1.893-1.261 1.262-1.893-1.893-1.892 1.893-1.262-1.262 1.892-1.893-1.892-1.892 1.262-1.261 1.892 1.891 1.893-1.891 1.261 1.261z","fill":"#fff"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1152:717","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1152:717"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1152:717","result":"shape"}})])])])
          )
        }
      }
    